/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganisationFastAccessView } from '../../models/organisation-fast-access-view';

export interface FastAccessViewGetOrganisationFastAccessView$Params {
}

export function fastAccessViewGetOrganisationFastAccessView(http: HttpClient, rootUrl: string, params?: FastAccessViewGetOrganisationFastAccessView$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganisationFastAccessView>> {
  const rb = new RequestBuilder(rootUrl, fastAccessViewGetOrganisationFastAccessView.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganisationFastAccessView>;
    })
  );
}

fastAccessViewGetOrganisationFastAccessView.PATH = '/fast-access-view/organisation';
